/* this file added by Bearer Web Developer  */
import { Button, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import styles from './confirmAndPay.module.scss';
import { useAppState } from "../../../states/app-state";
import DisabledClickLoading from "../../../components/DisabledClickLoading";
import { observer } from 'mobx-react-lite';
import Payment from "./payment";
import { useThemeMode } from "../../../states/contexts/theme";

const ConfirmAndPay: React.FC = observer(() => {

    const appState = useAppState();
    const order = appState.selectedOrder;
    const sign_up_stage = appState?.createAccount?.sign_up_stage;
    const cardInformation = appState.selectedOrder?.payment?.selectedCard;
    const [loading, setLoading] = React.useState(false);
    const { theme } = useThemeMode(); 
    const handleConfirm = () => {
        // added by Bearer Web Developer start
        const order = appState.selectedOrder;
        const needToConfirmMadeOfTransport = order?.selectedTransportOption && order?.transport?.editing;
        if (needToConfirmMadeOfTransport) {
            order?.ShowConfirmMadeOfTransport();
            return;
        }
        if (!order?.isReadyForPayment) return;
        if (!order?.scheduleOrder?.scheduleOrderSetting) return; // added by Bearer Web Developer
        // added by Bearer Web Developer end
        if (!appState.login.loggedin && sign_up_stage === 0) {
            return;
        } else {
            appState.selectedOrder?.payment?.setHasPayButton(true);
            appState.selectedOrder?.payment.setOpen(order!);
        }
    }
    const getCardOptions = async () => {
        setLoading(true);
        await appState.selectedOrder?.payment.prepareCardOptions(false);
        setLoading(false);
    }
    useEffect(() => {
        if (order?.isReadyForPayment) getCardOptions();
    }, [order?.isReadyForPayment])
    // modified by Bearer Web Developer start - scheduleOrderSetting statement added
    return (
        <div className={styles.confirm_and_pay} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {
                (!order?.isReadyForPayment || !order?.scheduleOrder?.scheduleOrderSetting) ? // scheduleOrderSetting statement added by Bearer Web Developer
                    <Button className={`${styles.confirm} ${(!order?.isReadyForPayment || !order?.scheduleOrder?.scheduleOrderSetting) ? styles.disabled : ''}`} onClick={handleConfirm} // disabled={!order?.isReadyForPayment} // disabled property commented by Bearer Web Developer - scheduleOrderSetting statement added by Bearer Web Developer
                    >
                        Confirm & Pay
                    </Button>
                    :
                    <>
                        {
                            cardInformation ?
                                <Payment setLoading={setLoading} cardInformation={cardInformation} /> :
                                <>
                                    {
                                        loading ? <CircularProgress /> :
                                            <Button className={styles.add_payment} onClick={handleConfirm} // disabled={!order?.isReadyForPayment} // disabled property commented by Bearer Web Developer
                                                classes={{ text: styles.add_payment_label }}
                                            >
                                                <img src="/add-card.svg" alt="" width={24} height={24} />
                                                <span>Add Payment Method</span>
                                            </Button>
                                    }
                                </>
                        }
                    </>
            }
            {loading && <DisabledClickLoading />} {/* added by Bearer Web Developer */}
        </div>
    )
    // modified by Bearer Web Developer end - scheduleOrderSetting statement added
})
export default ConfirmAndPay
